module.exports = __webpack_public_path__ + "static/media/user_d_fav_2.fef57e98.png";